import ninegrid from "../index.js";
import { ngEditableEx } from "./_ngCell.js";

class ngInputDate extends ngEditableEx
{
	#target;
	#type;
	
	constructor () {
		super();

		this.applyBaseStyle()

		this.#type = this.getAttribute("type") || "date";
		if (!["date","datetime-local","time","week","month"].includes(this.#type)) throw `invalid type : ${this.#type}`;
	}
	
	connectedCallback() {
		
		const height = parseInt(this.closest("tr").style.height, 10) - 1;
		
		var attr = [];
		for (var i = 0; i < this.attributes.length; i++) {
			if (["value","max","min","step"].includes(this.attributes[i].name)) attr.push(`${this.attributes[i].name}="${this.attributes[i].value}"`);
		}

		this.shadowRoot.innerHTML = `
			<style>
				input {
					--height: ${height}px;
				}
				input::-webkit-calendar-picker-indicator {
					--height: ${height}px;
				}
				:host(.invalid) input::-webkit-calendar-picker-indicator,
				input:invalid::-webkit-calendar-picker-indicator {
					--height: ${height}px;
				}
			</style>
	
			<input
				type="${this.#type}"
				data-placeholder="${this.getAttribute('placeholder') || 'Select'}"
				${attr.join(" ")}
				required
			/>
		`;
		
		super.connectedCallback();
		
		this.#target = this.shadowRoot.querySelector("input");
		
		$(this.cell).on("keydown", e => {
				
			switch (e.target.tagName) {
			case "TH": case "TD":
				if (["Enter"].includes(e.code)) {
					this.#target.focus();
					//this.#target.select();
				}
				break;
			}
		});

		this.#target.addEventListener("keydown", e => {
			if (["Enter","Escape"].includes(e.code)) {
				this.owner.cell.currentCell = this.cell;
			}
			else if (["Tab","PageUp","PageDown"].includes(e.code)) {
				this.owner.cell.currentCell = this.cell;
				this.owner.cell.moveCell(e);
			}
		});
	};
	
	dataRefresh = (a) => {

		var v = this.value;
		
		switch (this.#target.type) {
		case "date":
			v = v.substr(0, 10);
			break;
		case "datetime-local":
			v = v.substr(0, 16);
			break;
		case "time":
			var d = new Date(v);
			if (d != "Invalid Date") {
				v = ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2);
			}
			break;
		case "month":
			var d = new Date(v);
			if (d != "Invalid Date") {
				v = ("0000" + d.getFullYear()).slice(-4) + "-" + ("00" + (d.getMonth()+1)).slice(-2);
			}
			break;
		case "week":
			break;
		}
		
		this.#target.value = v;
		
		if (this.#isValidDate(v)) {
			ninegrid.j.querySelectorAll(this).removeClass("invalid");
		}
		else {
			ninegrid.j.querySelectorAll(this).addClass("invalid");
		}

		if (!a) this.reset();
	};
	
	#isValidDate = (v) => {

		if (ninegrid.isNull(v)) return true;

		if (typeof v !== "string") return false;
		
		//const v2 = v.replaceAll("-", "").replaceAll("/", "");
		
		var isValid = true;
		
		switch (this.#target.type) {
		case "date":
		case "datetime-local":
			var year	= Number(v.substr(0,4)); // 입력한 값의 0~4자리까지 (연)
			var month	= Number(v.substr(5,2)); // 입력한 값의 4번째 자리부터 2자리 숫자 (월)
			var day		= Number(v.substr(8,2)); // 입력한 값 6번째 자리부터 2자리 숫자 (일)
			
			if (isNaN(year) || isNaN(month) || isNaN(day)) {
				isValid = false;
			}
			else if (month < 1 || month > 12 || day < 1 || day > 31) {
				isValid = false;
			}
			else if ([4,6,9,11].includes(month) && day == 31) {
				isValid = false;
			}
			else if (month == 2) {
				var isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
				if (day > 29 || (day == 29 && !isleap)) {
					isValid = false;
				}
			}
			
			break;
		}
		
		if (isValid) {
			switch (this.#target.type) {
			case "datetime-local":
				var t		= v.substr(10,1);
				var hour	= Number(v.substr(11,2)); // 입력한 값의 0~4자리까지 (연)
				var min		= Number(v.substr(14,2)); // 입력한 값의 4번째 자리부터 2자리 숫자 (월)

				if (t != "T") {
					isValid = false;
				}
				else if (isNaN(hour) || isNaN(min)) {
					isValid = false;
				}
				else if (hour < 0 || hour > 23 || min < 0 || min > 59) {
					isValid = false;
				}

				break;
				
			case "month":
				var year	= Number(v.substr(0,4)); // 입력한 값의 0~4자리까지 (연)
				var month	= Number(v.substr(5,2)); // 입력한 값의 4번째 자리부터 2자리 숫자 (월)

				if (isNaN(year) || isNaN(month)) {
					isValid = false;
				}
				else if (month < 1 || month > 12) {
					isValid = false;
				}
				
				break;
				
			case "week":
				var year	= Number(v.substr(0,4));
				var w		= v.substr(5,1);
				var week	= Number(v.substr(6,2));

				if (w != "W") {
					isValid = false;
				}
				else if (isNaN(year) || isNaN(week)) {
					isValid = false;
				}
				else if (week <= 0 || week > 53) {
					isValid = false;
				}
				break;
			}
		}
		
		return isValid;//(new Date(v) == "Invalid Date") ? false : true) : false;
	}
}

if (!customElements.get('ng-input-date')) {
	customElements.define("ng-input-date", ngInputDate);
}
